import Typography from "@mui/material/Typography";
import color from "context/MaterialUITheme/color";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import getDisclosuresData from "./getDisclosuresData";
import useTracker from "components/CTracker/useTrackerContext";

const ClosingDisclosuresVerification: React.FC = () => {
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const linkToSign = step?.finalDisclosuresVerification?.link;
  const { status, message } = getDisclosuresData(step);

  return (
    <CTrackerTimelineItem
      last={!isBorrower}
      status={status}
      title="Closing Disclosures"
      tooltip="Your Closing Disclosures will contain your full closing package. These documents will be signed on your closing date."
      {...(status === "analyzing" &&
        message &&
        linkToSign &&
        loan && {
          action: {
            message: "Sign your Closing Documents",
            onClick: () => window.open(`${linkToSign}`, "_blank"),
          },
        })}
    >
      <Typography
        variant="h6"
        color={color[trackerStatusColor[status] as keyof typeof color]}
      >
        {status === "analyzing" && !message && "Analyzing"}
        {status === "analyzing" && !linkToSign && message && message}
        {status === "failed" && message}
        {status === "success" && message}
      </Typography>
    </CTrackerTimelineItem>
  );
};

export default ClosingDisclosuresVerification;
